import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function AxlCheckbox({ label, checked, onChange, ...props }) {
  const handleChange = (event) => {
    if (typeof onChange === 'function') {
      onChange(event);
    }
  };

  // Support both controlled (checked prop) and uncontrolled usage
  const checkboxProps = {
    ...props,
    onChange: handleChange,
    name: 'checked',
  };

  // Only pass checked prop if explicitly provided (controlled mode)
  if (checked !== undefined) {
    checkboxProps.checked = checked;
  }

  return (
    <FormControlLabel control={<Checkbox {...checkboxProps} />} label={label || ''} />
  );
}
